import { Injectable } from '@angular/core';
import { Router} from '@angular/router';
import { CampaignService } from './campaign.service';


@Injectable()
export class TransactionListGuard {

  constructor(public router: Router, private campaignService: CampaignService) { }

  resolve() {
    return this.campaignService.getTransactionsByCampaign(null,null);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/campaign/transaction-list.guard.ts